// Contracts — очередь работ для машины владельца.
//
// Воркер принимает и хранит, машина исполняет. Здесь описан ровно этот стык:
// демон спрашивает «что мне делать», отчитывается о результате и о том, почему
// не смог. Ничего исполняемого воркер не решает — он не знает даже, чем
// кончился прогон, пока машина не скажет.
import { z } from 'zod';

export const TgLaneSchema = z.enum(['fix', 'review', 'spec']);
export type TgLane = z.infer<typeof TgLaneSchema>;

/** Задача в том виде, в каком её забирает демон. */
export const TgWorkItemSchema = z.object({
  id: z.string(),
  lane: TgLaneSchema,
  kind: z.string(),               // bug | feature | question | ops | task_spec
  area: z.string(),
  title: z.string(),
  detail: z.string(),
  contour: z.string(),
  complexity: z.number().int().min(0).max(5),
  /** Кто принёс — чтобы агент понимал, чьими словами написана задача. */
  from_name: z.string(),
  created_at: z.string(),
});
export type TgWorkItem = z.infer<typeof TgWorkItemSchema>;

export const TgWorkPendingResSchema = z.object({
  ok: z.boolean(),
  items: z.array(TgWorkItemSchema),
  /** Автополоса остановлена (дневной лимит или два провала подряд). */
  paused: z.boolean(),
  pause_note: z.string(),
});
export type TgWorkPendingRes = z.infer<typeof TgWorkPendingResSchema>;

// Отчёт машины. `complexity` здесь — честная оценка по открытому репозиторию:
// поднять её и уйти из полосы `fix` можно, опустить нельзя (проверяет воркер).
export const TgWorkReportReqSchema = z.object({
  id: z.string().trim().min(1).max(64),
  state: z.enum(['done', 'failed', 'held']),
  report: z.string().max(6000).default(''),
  complexity: z.number().int().min(0).max(5).optional(),
  lane: TgLaneSchema.optional(),
  pr_number: z.string().max(16).default(''),
  deployed: z.string().max(200).default(''),
});
export type TgWorkReportReq = z.infer<typeof TgWorkReportReqSchema>;

export const TgWorkReportResSchema = z.object({
  ok: z.boolean(),
  /** Полоса после отчёта — машина могла сама себя выселить в `review`. */
  lane: TgLaneSchema,
  paused: z.boolean(),
});
export type TgWorkReportRes = z.infer<typeof TgWorkReportResSchema>;
